import axios from "axios";

const defaultState = {
  report: undefined,
};

export default {
  namespaced: true,

  state: {
    report: undefined,

    reportLoading: false,
  },

  mutations: {
    setReport(state, data) {
      state.report = data;
    },

    setReportLoading(state, data) {
      state.reportLoading = data;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    }
  },

  actions: {
    fetchReport({ commit }, reportID) {
      return axios.get(process.env.VUE_APP_API_URL + `reports/${reportID}`)
        .then(({ data }) => {
          commit("setReport", data);
        });
    },

    deleteClip({ commit, state }, clipID) {
      return axios.delete(process.env.VUE_APP_API_URL + `clips/${clipID}`)
        .then(() => {
          const report = Object.assign({}, state.report);
          report.clips = report.clips.filter(sr => sr.uuid != clipID);
          commit("setReport", report);
        });
    },

    updateClip({ dispatch }, { clipID, payload }) {
      return axios.put(process.env.VUE_APP_API_URL + `clips/${clipID}`, payload)
        .then(() => {
          dispatch("fetchReport", payload.reportID);
          dispatch("reports/fetchReports", {}, { root: true });
        });
    },

    saveClip(_, payload) {
      return axios.post(process.env.VUE_APP_API_URL + "clips", payload);
    },
  },
}